<div class="cb-margin-2x flex-col">
    <p class="mat-body-2 cb-margin-bottom-3x">
        To request Pre-consent, a signed Scheme Plan must be provided.
    </p>
    <cb-table [loaded]="true">
        <thead cbTableHead>
            <tr>
                <td></td>
                <td>Document Type</td>
                <td>File Types</td>
                <td>File Name</td>
                <td></td>
            </tr>
        </thead>
        <tbody cbTableBody>
            @for (documentType of defaultDocumentTypes; track documentType) {
                <tr id="{{ documentType?.dropZoneId }}">
                    <td>
                        @if (documentTypeRequired[documentType?.documentTypeId] === false) {
                            <mat-icon
                                matTooltip="Requirement Fufilled"
                                class="cb-help-cursor cb-primary"
                            >
                                check_circle</mat-icon
                            >
                        }
                        @if (documentTypeRequired[documentType?.documentTypeId] === true) {
                            <mat-icon matTooltip="Required" class="cb-help-cursor cb-error"
                                >error
                            </mat-icon>
                        }
                        @if (documentTypeRequired[documentType?.documentTypeId] == null) {
                            <mat-icon matTooltip="Not Required" class="cb-help-cursor cb-grey"
                                >info
                            </mat-icon>
                        }
                    </td>
                    <td>
                        <span class="mat-body-2">{{ documentType?.label }}</span>
                        <dl class="cb-error">
                            @for (
                                error of documentTypeFileErrors[documentType?.indexId];
                                track error
                            ) {
                                <dd>
                                    {{ error }}
                                </dd>
                            }
                        </dl>
                    </td>
                    <td>{{ documentType?.fileTypesLabel }}</td>
                    <td>{{ getFileName(documentType) | cbDasher }}</td>
                    <td cbTableShrinkCol cbTableStickyCol="end">
                        <label
                            class="mat-icon-button cb-margin-right"
                            style="margin-bottom: 3px; margin-top: 3px"
                            [ngClass]="{ 'cb-disabled ': disableUpload(documentType) }"
                        >
                            <input
                                #fileInput
                                style="display: none"
                                type="file"
                                [disabled]="disableUpload(documentType)"
                                [attr.id]="documentType.fileInputId"
                                accept="{{ documentType.accepts }}"
                                (change)="fileUploaded(documentType.indexId, $event)"
                            />
                            <button
                                mat-icon-button
                                [disabled]="disableUpload(documentType)"
                                (click)="triggerFileInput(fileInput)"
                                [ngClass]="{ 'cb-disabled ': disableUpload(documentType) }"
                            >
                                <mat-icon>file_upload</mat-icon>
                            </button>
                        </label>
                        <button
                            mat-icon-button
                            [disabled]="!files[documentType?.indexId]"
                            (cbClick)="removeFile(documentType)"
                        >
                            <mat-icon>clear</mat-icon>
                        </button>
                    </td>
                </tr>
            }
        </tbody>
    </cb-table>
</div>
